<template>
  <div class="skills">
    <h2>Skills & Hobbies</h2>
    <div class="grid-container">
      <div
        class="grid-item"
        v-for="item in skills"
        :key="item.heading"
        :data="item"
      >
        <h3 class="label">
          <i :class="`fas fa-${item.icon}`"></i> {{ item.heading }}
        </h3>
        <p class="desc">{{ item.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { skills } from "@/data/about.js";
export default {
  name: "Skills",
  data() {
    return {
      skills
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/_media_sizes.scss";
@import "@/assets/_colours.scss";
@import "@/assets/_font.scss";
@import "./style.scss";

.skills {
  .grid-container {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 20px;
  }

  .label {
    display: inline-block;
    padding: 5px 20px 5px 5px;
    border-radius: 2em;
    margin-bottom: 0;
    font-weight: 600;

    i {
      color: $accent-lightest-blue;
      background: $accent-darker-blue;
      padding: 10px 8px;
      border-radius: 2em;
      margin-right: 5px;
      font-size: 0.8em;
    }
  }

  .desc {
    margin-left: 5px;
    line-height: 1.6em;
    font-family: "Roboto", sans-serif;
  }
}

@media only screen and (min-width: $phone-S) {
  .skills {
    .grid-container {
    }
  }
}

@media only screen and (min-width: $tablet-potrait) {
  .skills {
    .grid-container {
      grid-template-columns: 1fr 1fr;
      grid-gap: 50px;
      .grid-item {
        margin: 0;
      }
    }
  }
}
</style>
